import { useState } from 'react';
import { ABOUT } from '@/constants/testIds';

const tabs = [
  {
    id: 'mission',
    testIdTab: ABOUT.missionTab,
    testIdContent: ABOUT.missionContent,
    label: 'Our Mission',
    title: 'Simplify billing with precision',
    content: 'Our dedicated team excels in simplifying complex billing procedures, ensuring accuracy and efficiency in every transaction. Say goodbye to billing headaches with our tailored solutions.',
    points: [
      'Assuring clients on delivered results',
      'Identifying and plugging revenue leaks',
      'Ensuring maximum profitability for business',
      'Streamlining intricate billing processes',
    ],
  },
  {
    id: 'vision',
    testIdTab: ABOUT.visionTab,
    testIdContent: ABOUT.visionContent,
    label: 'Our Vision',
    title: 'Maximize Profitability, Minimize Revenue Leakage',
    content: 'At Jhaishna Technologies, we are dedicated to helping telecom companies thrive by reducing revenue leakage and maximizing profitability through our innovative billing revenue management services.',
    points: [
      'Assuring clients on delivered results',
      'Identifying and plugging revenue leaks',
      'Ensuring maximum profitability for business',
      'Streamlining intricate billing processes',
    ],
  },
  {
    id: 'values',
    testIdTab: ABOUT.valuesTab,
    testIdContent: ABOUT.valuesContent,
    label: 'Our Values',
    title: 'Trusted Software Development Partner',
    content: 'With a strong foothold in India, Jhaishna has emerged as a reliable and innovative Software Development Company. We are committed to leveraging the latest technologies to meet your evolving business needs.',
    points: [
      'Assuring clients on delivered results',
      'Identifying and plugging revenue leaks',
      'Ensuring maximum profitability for business',
      'Streamlining intricate billing processes',
    ],
  },
];

const AboutSection = () => {
  const [activeTab, setActiveTab] = useState('mission');
  const currentTab = tabs.find((t) => t.id === activeTab);

  return (
    <section data-testid={ABOUT.section} className="py-24 lg:py-32 bg-surface/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="rounded-sm overflow-hidden border border-white/10">
              <img
                src="https://images.pexels.com/photos/1181738/pexels-photo-1181738.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Jhaishna Team"
                className="w-full h-[400px] object-cover"
              />
            </div>
            {/* Decorative accent */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-2 border-amber/30 rounded-sm" />
          </div>

          {/* Content with Tabs */}
          <div>
            <h2 className="font-heading text-3xl lg:text-4xl font-bold text-white mb-8 tracking-tight">
              Solutions for Your Business
            </h2>

            {/* Tab buttons */}
            <div className="flex gap-1 mb-8 border-b border-white/10">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  data-testid={tab.testIdTab}
                  onClick={() => setActiveTab(tab.id)}
                  className={`px-4 py-3 text-sm font-medium transition-colors relative ${
                    activeTab === tab.id
                      ? 'text-amber tab-active'
                      : 'text-slate-400 hover:text-slate-200'
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* Tab content */}
            {currentTab && (
              <div data-testid={currentTab.testIdContent} key={currentTab.id} className="animate-fade-in">
                <h3 className="font-heading text-lg font-bold text-white mb-3">{currentTab.title}</h3>
                <p className="text-sm text-slate-400 leading-relaxed mb-6">{currentTab.content}</p>
                <ul className="space-y-3">
                  {currentTab.points.map((point) => (
                    <li key={point} className="flex items-center gap-3">
                      <span className="w-1.5 h-1.5 bg-amber rounded-full flex-shrink-0" />
                      <span className="text-sm text-slate-300">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
